export function validarData(data) {
  let dataPassada = new Date(data);
  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 120);

  if (dataPassada > today) {
    return false;
  } else if (dataPassada < minDate) {
    return false;
  } else {
    return true;
  }
}

export function getMinDate() {
  let hoje = new Date();
  let data = new Date();
  data.setFullYear(hoje.getFullYear() - 120);

  return data;
}

export function getRandomColor() {
  // Gera um valor hexadecimal aleatório
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function filterNumberString(value, options = {}) {
  const numStr = value.replace(/[^0-9]/g, "");
  const { valueMax, length } = options;

  if (
    length &&
    valueMax &&
    (numStr.length > length || parseInt(numStr) > valueMax)
  ) {
    return valueMax;
  }

  return numStr.length > 0 ? `${parseInt(numStr)}` : numStr;
}
